import { render, staticRenderFns } from "./InspectionCreate.vue?vue&type=template&id=dff2524a&scoped=true"
import script from "./InspectionCreate.vue?vue&type=script&lang=js"
export * from "./InspectionCreate.vue?vue&type=script&lang=js"
import style0 from "./InspectionCreate.vue?vue&type=style&index=0&id=dff2524a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff2524a",
  null
  
)

export default component.exports